module.exports = __webpack_public_path__ + "img/keitaro-landing-step-5.en.e0bf1030.jpg";